import React , { useEffect, useMemo, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell} from '@fortawesome/free-solid-svg-icons'
import { faEnvelope} from '@fortawesome/free-solid-svg-icons'
import { faSearch} from '@fortawesome/free-solid-svg-icons'
import { faBars} from '@fortawesome/free-solid-svg-icons'
import logo from '../Images/logo-main-black.png'

import profilePictureContImage from '../Images/defprofile.png'

// firebase
import {db} from '../firebase';
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { collection, query, getDocs, onSnapshot, where } from "firebase/firestore";
import { getDatabase, onValue, ref } from "firebase/database";
import { useLocation as useGeoLocation } from '../LocationContext';
import { logInstructorLogout } from '../utils/instructorActivityLogger';

//routers
import {useLocation as useRouterLocation, useNavigate } from "react-router-dom";
import {Link } from "react-router-dom";
import {NavLink } from "react-router-dom";

//mobile navbar
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';

//icons
import { faHome} from '@fortawesome/free-solid-svg-icons'
import { faUser} from '@fortawesome/free-solid-svg-icons'
import { faBookOpen} from '@fortawesome/free-solid-svg-icons'
import { faClipboardList} from '@fortawesome/free-solid-svg-icons'
import { faComments} from '@fortawesome/free-solid-svg-icons'

const DEFAULT_CHANNEL_NAMES = ['genral', 'general']
const MESSAGE_SUMMARY_CACHE_KEY = 'ubunifu-instructor-message-summary-v1'

const getTimestamp = (value) => {
  if (!value) return 0
  if (typeof value === 'number') return value
  if (value?.toMillis) return value.toMillis()
  if (value?.seconds) return value.seconds * 1000
  return 0
}

const chunkArray = (items, size) => {
  const chunks = []
  for (let index = 0; index < items.length; index += size) {
    chunks.push(items.slice(index, index + size))
  }
  return chunks
}

const normalizeSearchText = (value) => String(value || '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim()

const buildFireflyReadId = (instructorId, studentId, reportId) => (
  `${instructorId}_${studentId}_${reportId}`.replace(/[^a-zA-Z0-9_-]/g, '_')
)

const buildAssignmentSubmissionReadId = (instructorId, submissionId) => (
  `${instructorId}_${submissionId}`.replace(/[^a-zA-Z0-9_-]/g, '_')
)

const readMessageSummaryCache = (userId) => {
  if (typeof window === 'undefined' || !userId) return null
  try {
    const rawCache = window.sessionStorage.getItem(MESSAGE_SUMMARY_CACHE_KEY)
    if (!rawCache) return null
    const parsed = JSON.parse(rawCache)
    return parsed?.[userId] || null
  } catch (error) {
    return null
  }
}

const writeMessageSummaryCache = (userId, value) => {
  if (typeof window === 'undefined' || !userId) return
  try {
    const rawCache = window.sessionStorage.getItem(MESSAGE_SUMMARY_CACHE_KEY)
    const parsed = rawCache ? JSON.parse(rawCache) : {}
    parsed[userId] = value
    window.sessionStorage.setItem(MESSAGE_SUMMARY_CACHE_KEY, JSON.stringify(parsed))
  } catch (error) {
    // Ignore cache failures and rely on live updates.
  }
}

function DashnavIn() {

    const [userProfilePicture, setProfilePicture] = useState(profilePictureContImage);
    const [currentUserId, setCurrentUserId] = useState('');
    const [messageUnreadCount, setMessageUnreadCount] = useState(0);
    const [unreadMessages, setUnreadMessages] = useState([]);
    const [isMessagesOpen, setIsMessagesOpen] = useState(false);
    const [fireflyUnreadReports, setFireflyUnreadReports] = useState([]);
    const [unreadAssignmentSubmissions, setUnreadAssignmentSubmissions] = useState([]);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [searchableStudents, setSearchableStudents] = useState([]);
    const messagesDropdownRef = useRef(null);
    const notificationDropdownRef = useRef(null);
    const profileDropdownRef = useRef(null);
    const searchDropdownRef = useRef(null);

    //instantiate auth
    const auth = getAuth();
    const realtimeDb = getDatabase();
    let navigate = useNavigate();
    const routerLocation = useRouterLocation();
    const { location: geoLocation, currency } = useGeoLocation();

    const formatMessagePreview = (htmlText) => {
      if (!htmlText) return "";
      if (typeof window === "undefined") return htmlText;
      const temp = document.createElement("div");
      temp.innerHTML = htmlText;
      return (temp.textContent || temp.innerText || "").replace(/\s+/g, " ").trim();
    };

    const formatMessageTime = (timestamp) => {
      if (!timestamp) return "";
      return new Date(timestamp).toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      });
    };

    const totalNotificationCount = fireflyUnreadReports.length + unreadAssignmentSubmissions.length;

    const formatAssignmentSubmissionPreview = (submission) => {
      if (!submission) return "Open submission";

      const assignmentTitle = submission.assignmentTitle || submission.title || "Assignment";
      const courseName = submission.courseName || "";
      const responseHtml = Array.isArray(submission.responseItemsHtml)
        ? submission.responseItemsHtml.find(Boolean)
        : "";
      const responseText = Array.isArray(submission.responseItems)
        ? submission.responseItems.find(Boolean)
        : submission.responseText || submission.answerText || submission.notes || "";
      const linkLabel = submission.githubLink || submission.githubUrl || submission.repositoryUrl || submission.repoLink
        ? "GitHub link submitted"
        : submission.projectLink || submission.projectUrl || submission.liveLink || submission.liveUrl
          ? "Project link submitted"
          : "";
      const preview = formatMessagePreview(responseHtml || responseText || "") || linkLabel;

      return [assignmentTitle, courseName || preview].filter(Boolean).join(" • ");
    };

    const flatSearchResults = useMemo(() => {
      const term = normalizeSearchText(searchTerm);
      if (!term) return [];

      return searchableStudents
        .filter((student) => student.searchText.includes(term))
        .slice(0, 8);
    }, [searchTerm, searchableStudents]);

    const groupedSearchResults = useMemo(() => (
      flatSearchResults.length ? [{ name: 'Students', items: flatSearchResults }] : []
    ), [flatSearchResults]);

    const closeSearchDropdown = () => {
      setIsSearchOpen(false);
    };

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (!searchDropdownRef.current?.contains(event.target)) {
          setIsSearchOpen(false);
        }
        if (!messagesDropdownRef.current?.contains(event.target)) {
          setIsMessagesOpen(false);
        }
        if (!notificationDropdownRef.current?.contains(event.target)) {
          setIsNotificationOpen(false);
        }
        if (!profileDropdownRef.current?.contains(event.target)) {
          setIsProfileMenuOpen(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
      //if user is logged in 
      const uid = user.uid;
      setCurrentUserId(uid);
      const cachedMessageSummary = readMessageSummaryCache(uid);
      if (cachedMessageSummary) {
        setMessageUnreadCount(Number(cachedMessageSummary.count) || 0);
        setUnreadMessages(Array.isArray(cachedMessageSummary.items) ? cachedMessageSummary.items : []);
      }

        // get employee prof pic
        const m = query(collection(db, "Employees"), where("docId", "==", uid));
        getDocs(m).then((QuerySnapshot)=>{
            QuerySnapshot.forEach((doc)=>{
              const profilePic = doc.data().profilePic;

              setProfilePicture(profilePic);
              let myxx = profilePic + "1";          
              if(myxx === "undefined1"){
                setProfilePicture(profilePictureContImage);         
              }else{
                
              }

            })
        })

  
        const q = query(collection(db, "users"), where("userId", "==", uid));
        getDocs(q).then((QuerySnapshot)=>{
            QuerySnapshot.forEach((doc)=>{
  
            let userType = doc.data().userType;


            if (userType !== "Instructor"){
                console.log("You are not an instructor chief!")
                navigate("/dashboard")
            }
  
           
            })
        })




  
      } else {
        // User is signed out
        setCurrentUserId('');
        setMessageUnreadCount(0);
        setUnreadMessages([]);
        setIsMessagesOpen(false);
        setFireflyUnreadReports([]);
        setUnreadAssignmentSubmissions([]);
        setIsNotificationOpen(false);
        setIsProfileMenuOpen(false);
        setSearchTerm('');
        setIsSearchOpen(false);
        setSearchableStudents([]);
        }
    });

    return () => unsubscribe();
    }, [auth, navigate]);

    useEffect(() => {
      if (!currentUserId) {
        setMessageUnreadCount(0);
        return undefined;
      }

      let dmUnreadTotal = 0;
      let channelUnreadTotal = 0;
      let directUnreadEntries = [];
      let channelUnreadEntries = [];
      let isMounted = true;
      let channelUnsubscribers = [];

      const syncTotal = () => {
        if (!isMounted) return;
        const totalCount = dmUnreadTotal + channelUnreadTotal;
        const nextItems = [...directUnreadEntries, ...channelUnreadEntries]
          .sort((left, right) => (right.timestamp || 0) - (left.timestamp || 0));
        setMessageUnreadCount(totalCount);
        setUnreadMessages(nextItems);
        writeMessageSummaryCache(currentUserId, {
          count: totalCount,
          items: nextItems,
          updatedAt: Date.now()
        });
      };

      const chatsUnsubscribe = onValue(ref(realtimeDb, 'chats'), async (snapshot) => {
        if (!snapshot.exists()) {
          dmUnreadTotal = 0;
          directUnreadEntries = [];
          syncTotal();
          return;
        }

        const allChats = snapshot.val();
        const chatKeys = Object.keys(allChats).filter((key) => key.split('_').includes(currentUserId));
        const seenMessageIds = new Set();
        const unreadByUser = {};

        dmUnreadTotal = chatKeys.reduce((total, key) => {
          const chatMessages = Object.entries(allChats[key] || {});
          const unreadMessages = chatMessages.filter(([messageKey, message]) => {
            const uniqueKey = message.messageId || messageKey;
            if (seenMessageIds.has(uniqueKey)) return false;
            if (message.receiverId !== currentUserId || message.isRead) return false;
            seenMessageIds.add(uniqueKey);

            const otherUserId = key.split('_').find((id) => id !== currentUserId);
            const messageTimestamp = getTimestamp(message.timestamp) || message.clientTimestamp || 0;
            if (otherUserId) {
              if (!unreadByUser[otherUserId]) {
                unreadByUser[otherUserId] = {
                  type: 'dm',
                  userId: otherUserId,
                  unreadCount: 0,
                  preview: message.text || "",
                  timestamp: messageTimestamp
                };
              }

              unreadByUser[otherUserId].unreadCount += 1;
              if (messageTimestamp >= unreadByUser[otherUserId].timestamp) {
                unreadByUser[otherUserId].preview = message.text || "";
                unreadByUser[otherUserId].timestamp = messageTimestamp;
              }
            }

            return true;
          });

          return total + unreadMessages.length;
        }, 0);

        const unreadEntries = Object.values(unreadByUser).sort((left, right) => right.timestamp - left.timestamp);
        directUnreadEntries = unreadEntries.map((entry) => ({
          ...entry,
          name: "Conversation",
          avatar: profilePictureContImage,
          course: "",
        }));
        syncTotal();

        try {
          const resolvedEntries = await Promise.all(
            unreadEntries.map(async (entry) => {
              const userSnapshot = await getDocs(
                query(collection(db, 'users'), where('userId', '==', entry.userId))
              );

              if (!userSnapshot.empty) {
                const userDoc = userSnapshot.docs[0]?.data() || {};
                return {
                  ...entry,
                  name: userDoc.bio || userDoc.userName || "Student",
                  avatar: userDoc.profilePic || profilePictureContImage,
                  course: userDoc.course || "",
                };
              }

              const employeeSnapshot = await getDocs(
                query(collection(db, 'Employees'), where('docId', '==', entry.userId))
              );
              const employeeDoc = employeeSnapshot.docs[0]?.data() || {};

              return {
                ...entry,
                name: employeeDoc.employeeName || "Instructor",
                avatar: employeeDoc.profilePic || profilePictureContImage,
                course: employeeDoc.role || "Instructor",
              };
            })
          );

          if (!isMounted) return;
          directUnreadEntries = resolvedEntries;
          syncTotal();
        } catch (error) {
          if (!isMounted) return;
          syncTotal();
        }
      });

      const loadChannelUnread = async () => {
        try {
          const teamSnapshot = await getDocs(collection(db, 'Teams'));
          if (!isMounted) return;

          const channels = teamSnapshot.docs
            .map((teamDoc) => ({ id: teamDoc.id, ...teamDoc.data() }))
            .filter((channel) => {
              const channelName = String(channel.teamName || '').trim().toLowerCase();
              const isDefaultChannel = DEFAULT_CHANNEL_NAMES.includes(channelName);
              const isOpenChannel = isDefaultChannel || !Array.isArray(channel.members) || channel.members.length === 0;
              return isOpenChannel || channel.members.includes(currentUserId);
            });

          const channelReadAt = {};
          const channelMessages = {};

          const recalculateChannelUnread = () => {
            const nextChannelEntries = [];
            channelUnreadTotal = channels.reduce((total, channel) => {
              const lastRead = channelReadAt[channel.id] || 0;
              const messages = channelMessages[channel.id] || [];
              const unreadMessages = messages.filter((message) => (
                (getTimestamp(message.timestamp) || message.clientTimestamp || 0) > lastRead &&
                message.senderId !== currentUserId
              ));
              const unreadCount = unreadMessages.length;

              if (unreadCount > 0) {
                const latestMessage = unreadMessages.reduce((latest, current) => {
                  if (!latest) return current;
                  return (getTimestamp(current.timestamp) || current.clientTimestamp || 0) >
                    (getTimestamp(latest.timestamp) || latest.clientTimestamp || 0) ? current : latest;
                }, null);

                nextChannelEntries.push({
                  type: 'channel',
                  userId: `channel-${channel.id}`,
                  name: `# ${channel.teamName || 'Channel'}`,
                  avatar: profilePictureContImage,
                  course: 'Workspace channel',
                  unreadCount,
                  preview: latestMessage?.text || channel.teamDesc || '',
                  timestamp: latestMessage ? (getTimestamp(latestMessage.timestamp) || latestMessage.clientTimestamp || 0) : 0
                });
              }

              return total + unreadCount;
            }, 0);
            channelUnreadEntries = nextChannelEntries;
            syncTotal();
          };

          channelUnsubscribers = channels.flatMap((channel) => {
            const readUnsubscribe = onValue(ref(realtimeDb, `channelReads/${channel.id}/${currentUserId}`), (snapshot) => {
              channelReadAt[channel.id] = snapshot.val() || 0;
              recalculateChannelUnread();
            });

            const channelUnsubscribe = onValue(ref(realtimeDb, `channelChats/${channel.id}`), (snapshot) => {
              channelMessages[channel.id] = snapshot.exists() ? Object.values(snapshot.val()) : [];
              recalculateChannelUnread();
            });

            return [readUnsubscribe, channelUnsubscribe];
          });
        } catch (error) {
          channelUnreadTotal = 0;
          channelUnreadEntries = [];
          syncTotal();
        }
      };

      loadChannelUnread();

      return () => {
        isMounted = false;
        chatsUnsubscribe();
        channelUnsubscribers.forEach((unsubscribe) => unsubscribe());
      };
    }, [currentUserId, realtimeDb]);

    useEffect(() => {
      if (!currentUserId) {
        setFireflyUnreadReports([]);
        return undefined;
      }

      let isMounted = true;
      let sessionUnsubscribers = [];
      let readUnsubscribe = () => {};
      let readIds = new Set();
      const sessionMap = {};
      const studentMap = {};

      const syncFireflyUnread = () => {
        if (!isMounted) return;
        const nextReports = Object.entries(sessionMap)
          .flatMap(([studentId, reports]) => (
            reports
              .filter((report) => report.status !== 'started')
              .filter((report) => !readIds.has(buildFireflyReadId(currentUserId, studentId, report.id)))
              .map((report) => ({
                ...report,
                type: 'firefly',
                studentId,
                studentName: studentMap[studentId]?.name || report.studentName || 'Student',
                studentEmail: studentMap[studentId]?.email || '',
                avatar: studentMap[studentId]?.avatar || profilePictureContImage,
                timestamp: Number(report.endedAtMs) || Number(report.startedAtMs) || 0,
              }))
          ))
          .sort((left, right) => (right.timestamp || 0) - (left.timestamp || 0));

        setFireflyUnreadReports(nextReports);
      };

      const loadFireflyReports = async () => {
        try {
          const classesSnapshot = await getDocs(query(collection(db, 'allclasses'), where('instructor', '==', currentUserId)));
          if (!isMounted) return;

          const classIds = classesSnapshot.docs
            .map((classDoc) => classDoc.data()?.roomID || classDoc.id)
            .filter(Boolean);

          const membershipSnapshots = await Promise.all(
            classIds.map((classId) => getDocs(query(collection(db, 'StudentsInClass'), where('classID', '==', classId))))
          );
          if (!isMounted) return;

          const memberships = membershipSnapshots.flatMap((snapshot) => (
            snapshot.docs.map((studentDoc) => ({ id: studentDoc.id, ...studentDoc.data() }))
          ));
          const studentIds = Array.from(new Set(
            memberships.map((student) => student.studentID || student.userId).filter(Boolean)
          ));

          memberships.forEach((student) => {
            const studentId = student.studentID || student.userId;
            if (!studentId) return;
            studentMap[studentId] = {
              name: student.name || student.studentEmail || 'Student',
              email: student.studentEmail || '',
              avatar: student.profilePic || profilePictureContImage,
            };
          });

          const profileSnapshots = await Promise.all(
            chunkArray(studentIds, 10).map((studentChunk) => (
              getDocs(query(collection(db, 'users'), where('userId', 'in', studentChunk)))
            ))
          );
          if (!isMounted) return;

          profileSnapshots.forEach((snapshot) => {
            snapshot.docs.forEach((studentDoc) => {
              const student = studentDoc.data() || {};
              const studentId = student.userId || studentDoc.id;
              studentMap[studentId] = {
                ...(studentMap[studentId] || {}),
                name: student.bio || student.name || studentMap[studentId]?.name || 'Student',
                email: student.userEmail || studentMap[studentId]?.email || '',
                avatar: student.profilePic || studentMap[studentId]?.avatar || profilePictureContImage,
              };
            });
          });

          readUnsubscribe = onSnapshot(
            query(collection(db, 'fireflyReportReads'), where('instructorId', '==', currentUserId)),
            (snapshot) => {
              readIds = new Set(snapshot.docs.map((readDoc) => readDoc.id));
              syncFireflyUnread();
            }
          );

          sessionUnsubscribers = studentIds.map((studentId) => (
            onSnapshot(collection(db, 'plm', studentId, 'sessions'), (snapshot) => {
              sessionMap[studentId] = snapshot.docs.map((sessionDoc) => {
                const data = sessionDoc.data() || {};
                return {
                  id: sessionDoc.id,
                  status: String(data.status || '').trim(),
                  studentName: data.studentName || studentMap[studentId]?.name || 'Student',
                  summary: String(data.summary || '').trim(),
                  sessionFocus: String(data.sessionFocus || '').trim(),
                  startedAtMs: Number(data.startedAtMs) || 0,
                  endedAtMs: Number(data.endedAtMs) || 0,
                };
              });
              syncFireflyUnread();
            })
          ));
        } catch (error) {
          setFireflyUnreadReports([]);
        }
      };

      loadFireflyReports();

      return () => {
        isMounted = false;
        readUnsubscribe();
        sessionUnsubscribers.forEach((unsubscribe) => unsubscribe());
      };
    }, [currentUserId]);

    useEffect(() => {
      if (!currentUserId) {
        setUnreadAssignmentSubmissions([]);
        return undefined;
      }

      let isMounted = true;
      let readUnsubscribe = () => {};
      let submissionUnsubscribers = [];
      let readIds = new Set();
      const submissionMap = {};

      const syncUnreadAssignmentSubmissions = () => {
        if (!isMounted) return;

        const nextSubmissions = Object.values(submissionMap)
          .filter((submission) => !readIds.has(buildAssignmentSubmissionReadId(currentUserId, submission.id)))
          .sort((left, right) => (right.timestamp || 0) - (left.timestamp || 0));

        setUnreadAssignmentSubmissions(nextSubmissions);
      };

      const loadUnreadAssignmentSubmissions = async () => {
        try {
          const assignmentsSnapshot = await getDocs(
            query(collection(db, 'courseAssignments'), where('instructorId', '==', currentUserId))
          );
          if (!isMounted) return;

          const assignmentMap = assignmentsSnapshot.docs.reduce((acc, assignmentDoc) => {
            acc[assignmentDoc.id] = { id: assignmentDoc.id, ...assignmentDoc.data() };
            return acc;
          }, {});

          const assignmentIds = Object.keys(assignmentMap);

          readUnsubscribe = onSnapshot(
            query(collection(db, 'assignmentSubmissionReads'), where('instructorId', '==', currentUserId)),
            (snapshot) => {
              readIds = new Set(snapshot.docs.map((readDoc) => readDoc.id));
              syncUnreadAssignmentSubmissions();
            }
          );

          if (!assignmentIds.length) {
            setUnreadAssignmentSubmissions([]);
            return;
          }

          submissionUnsubscribers = chunkArray(assignmentIds, 10).map((assignmentChunk) => (
            onSnapshot(
              query(collection(db, 'assignmentSubmissions'), where('assignmentId', 'in', assignmentChunk)),
              (snapshot) => {
                snapshot.docChanges().forEach((change) => {
                  const submissionId = change.doc.id;
                  if (change.type === 'removed') {
                    delete submissionMap[submissionId];
                    return;
                  }

                  const submission = change.doc.data() || {};
                  const assignment = assignmentMap[submission.assignmentId] || {};
                  const timestamp = getTimestamp(submission.updatedAt)
                    || getTimestamp(submission.submittedAt)
                    || Number(submission.updatedAtMs)
                    || Number(submission.submittedAtMs)
                    || getTimestamp(submission.createdAt)
                    || 0;

                  submissionMap[submissionId] = {
                    id: submissionId,
                    ...submission,
                    type: 'assignment',
                    assignmentId: submission.assignmentId || '',
                    assignmentTitle: assignment.title || assignment.assignmentTitle || 'Assignment',
                    courseName: assignment.courseName || submission.courseName || '',
                    studentId: submission.studentId || submission.studentID || submission.userId || submission.submittedById || '',
                    studentName: submission.studentName || submission.name || submission.studentEmail || 'Student',
                    studentEmail: submission.studentEmail || submission.email || submission.userEmail || '',
                    avatar: submission.profilePic || profilePictureContImage,
                    timestamp,
                  };
                });

                syncUnreadAssignmentSubmissions();
              }
            )
          ));
        } catch (error) {
          console.error('Error loading unread assignment submissions:', error);
          if (isMounted) {
            setUnreadAssignmentSubmissions([]);
          }
        }
      };

      loadUnreadAssignmentSubmissions();

      return () => {
        isMounted = false;
        readUnsubscribe();
        submissionUnsubscribers.forEach((unsubscribe) => unsubscribe());
      };
    }, [currentUserId]);

    useEffect(() => {
      if (!currentUserId) {
        setSearchableStudents([]);
        return undefined;
      }

      let isMounted = true;

      const loadSearchStudents = async () => {
        try {
          const classesSnapshot = await getDocs(query(collection(db, 'allclasses'), where('instructor', '==', currentUserId)));
          if (!isMounted) return;

          const classList = classesSnapshot.docs.map((classDoc) => ({ id: classDoc.id, ...classDoc.data() }));
          const classMap = classList.reduce((acc, classItem) => {
            acc[classItem.roomID || classItem.id] = classItem;
            return acc;
          }, {});

          const classIds = classList
            .map((classItem) => classItem.roomID || classItem.id)
            .filter(Boolean);

          const membershipSnapshots = await Promise.all(
            classIds.map((classId) => getDocs(query(collection(db, 'StudentsInClass'), where('classID', '==', classId))))
          );
          if (!isMounted) return;

          const memberships = membershipSnapshots.flatMap((snapshot) => (
            snapshot.docs.map((studentDoc) => ({ id: studentDoc.id, ...studentDoc.data() }))
          ));

          const studentIds = Array.from(new Set(
            memberships.map((student) => student.studentID || student.userId).filter(Boolean)
          ));

          const studentMap = memberships.reduce((acc, student) => {
            const studentId = student.studentID || student.userId;
            if (!studentId) return acc;

            if (!acc[studentId]) {
              acc[studentId] = {
                studentId,
                name: student.name || student.studentEmail || 'Student',
                email: student.studentEmail || '',
                avatar: student.profilePic || profilePictureContImage,
                course: student.course || '',
                cohortDate: student.cohortDate || '',
                classNames: []
              };
            }

            const className = classMap[student.classID]?.classDesc || student.className || student.course || 'Class';
            if (!acc[studentId].classNames.includes(className)) {
              acc[studentId].classNames.push(className);
            }

            return acc;
          }, {});

          const profileSnapshots = await Promise.all(
            chunkArray(studentIds, 10).map((studentChunk) => (
              getDocs(query(collection(db, 'users'), where('userId', 'in', studentChunk)))
            ))
          );
          if (!isMounted) return;

          profileSnapshots.forEach((snapshot) => {
            snapshot.docs.forEach((studentDoc) => {
              const profile = studentDoc.data() || {};
              const studentId = profile.userId || studentDoc.id;
              if (!studentMap[studentId]) {
                studentMap[studentId] = {
                  studentId,
                  name: profile.bio || profile.name || 'Student',
                  email: profile.userEmail || '',
                  avatar: profile.profilePic || profilePictureContImage,
                  course: profile.course || '',
                  cohortDate: '',
                  classNames: []
                };
              }

              studentMap[studentId] = {
                ...studentMap[studentId],
                name: profile.bio || profile.name || studentMap[studentId].name,
                email: profile.userEmail || studentMap[studentId].email,
                avatar: profile.profilePic || studentMap[studentId].avatar,
                course: profile.course || studentMap[studentId].course,
              };
            });
          });

          setSearchableStudents(
            Object.values(studentMap)
              .map((student) => ({
                ...student,
                classCount: student.classNames.length,
                searchText: normalizeSearchText([
                  student.name,
                  student.email,
                  student.course,
                  student.cohortDate,
                  student.classNames.join(' ')
                ].join(' '))
              }))
              .sort((first, second) => first.name.localeCompare(second.name))
          );
        } catch (error) {
          console.error('Error loading student search:', error);
          if (isMounted) {
            setSearchableStudents([]);
          }
        }
      };

      loadSearchStudents();

      return () => {
        isMounted = false;
      };
    }, [currentUserId]);

    function goToProfile(){
      setIsProfileMenuOpen(false);
      navigate("/profile")
    }

    function goToEditProfile(){
      setIsProfileMenuOpen(false);
      navigate("/edit-profile")
    }

    function goToWorkspace(){
      setIsMessagesOpen(false);
      navigate("/workspace")
    }

    async function handleLogout() {
      setIsProfileMenuOpen(false);
      try {
        if (auth.currentUser?.uid) {
          await logInstructorLogout({
            userId: auth.currentUser.uid,
            profile: {
              email: auth.currentUser.email || '',
            },
            path: routerLocation.pathname,
            routeName: 'Logout',
            geo: {
              city: geoLocation?.city,
              region: geoLocation?.region,
              country: currency?.countryName || geoLocation?.country,
              timezone: geoLocation?.timezone,
            },
            metadata: {
              trigger: 'profile_menu',
            },
          });
        }
        await signOut(auth);
        navigate("/login");
      } catch (error) {
        console.error("Logout failed:", error);
      }
    }

    function openMessageThread(message) {
      setIsMessagesOpen(false);

      if (message.type === 'channel') {
        navigate("/workspace");
        return;
      }

      navigate("/workspace", {
        state: {
          openDMUserId: message.userId,
          openDMName: message.name,
          openDMAvatar: message.avatar || profilePictureContImage,
          openDMCourse: message.course || "",
        },
      });
    }

    function openFireflyReport(report) {
      setIsNotificationOpen(false);
      navigate("/my-courses", {
        state: {
          openTab: 'firefly',
          openFireflyStudentId: report.studentId,
          openFireflyReportId: report.id,
        },
      });
    }

    function openAssignmentSubmission(submission) {
      setIsNotificationOpen(false);
      navigate("/assignments", {
        state: {
          openAssignmentId: submission.assignmentId,
          openSubmissionId: submission.id,
        },
      });
    }

    function openSearchResult(student) {
      setSearchTerm('');
      closeSearchDropdown();
      navigate(`/student-profile/${student.studentId}`, {
        state: {
          searchStudentPreview: student,
        },
      });
    }

  return (
    <div className='dashNav'> 
        <div className='dashMenuIcon'>
          {/* <FontAwesomeIcon icon={faBars} className="dashNavIco "/> */}

          {[false, ].map((expand) => (
            <Navbar key={expand} bg="" className="" expand={expand} >
              <Container fluid>
              
                <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
                <Navbar.Offcanvas
                  id={`offcanvasNavbar-expand-${expand}`}
                  aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                  placement="start"
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                    <img src={logo} alt="" className='dashnavLogo' />
                    </Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <Nav className="justify-content-end flex-grow-1 pe-3">

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/dashboard" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faHome} className="laftNavIcon"/>
                          Dashboard
                        </Link>
                      </div> 
                      
                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/my-courses" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faBookOpen} className="laftNavIcon"/>
                          My Courses
                        </Link>
                      </div>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/assignments" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faClipboardList} className="laftNavIcon"/>
                          Assignments
                        </Link>
                      </div>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/workspace" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faComments} className="laftNavIcon"/>
                          Workspace
                        </Link>
                      </div>

                      <p className='mobileMenuTitles'>ACCOUNT</p>
                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/profile" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faUser} className="laftNavIcon "/>
                          Profile
                        </Link>
                      </div>
                    </Nav>

                  </Offcanvas.Body>
                </Navbar.Offcanvas>
              </Container>
            </Navbar>
          ))}
        </div>

        <div className='searchDashCont' ref={searchDropdownRef}>
          <input
            placeholder='Search students by name, email, or class'
            value={searchTerm}
            onFocus={() => {
              setIsMessagesOpen(false);
              setIsNotificationOpen(false);
              setIsProfileMenuOpen(false);
              if (searchTerm.trim()) {
                setIsSearchOpen(true);
              }
            }}
            onChange={(event) => {
              const nextValue = event.target.value;
              setSearchTerm(nextValue);
              setIsSearchOpen(Boolean(nextValue.trim()));
            }}
            onKeyDown={(event) => {
              if (event.key === 'Escape') {
                closeSearchDropdown();
                return;
              }

              if (event.key === 'Enter' && flatSearchResults.length > 0) {
                event.preventDefault();
                openSearchResult(flatSearchResults[0]);
              }
            }}
          />
          <FontAwesomeIcon icon={faSearch} className="dashSearchIcon "/>

          {isSearchOpen && (
            <div className='dashSearchDropdown'>
              {groupedSearchResults.length === 0 ? (
                <div className='dashSearchEmpty'>
                  No students found for "{searchTerm}".
                </div>
              ) : (
                groupedSearchResults.map((group) => (
                  <div key={group.name} className='dashSearchGroup'>
                    <div className='dashSearchGroupTitle'>{group.name}</div>
                    <div className='dashSearchGroupList'>
                      {group.items.map((result) => (
                        <button
                          key={result.studentId}
                          type='button'
                          className='dashSearchResult dashSearchStudentResult'
                          onClick={() => openSearchResult(result)}
                        >
                          <div className='dashSearchStudentIdentity'>
                            <img src={result.avatar || profilePictureContImage} alt={result.name} className='dashSearchStudentAvatar' />
                            <div className='dashSearchResultMain'>
                              <strong>{result.name}</strong>
                              <p>{result.email || result.course || 'Student profile'}</p>
                            </div>
                          </div>
                          <span className='dashSearchResultMeta'>
                            {result.classCount} class{result.classCount === 1 ? '' : 'es'}
                          </span>
                        </button>
                      ))}
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
        

        <div className='allNotifCont'>

          <div className='messageDropdownWrap' ref={messagesDropdownRef}>
          <button
            type='button'
            className='chatCont messageToggleBtn'
            onClick={() => setIsMessagesOpen((currentValue) => !currentValue)}
          >
            <FontAwesomeIcon icon={faEnvelope} className="dashNoticIcon "/>
            {messageUnreadCount > 0 && (
              <p className='notifCounter'>{messageUnreadCount > 99 ? '99+' : messageUnreadCount}</p>
            )}
          </button>
          {isMessagesOpen && (
            <div className='messageDropdownMenu'>
              <div className='messageDropdownHeader'>
                <h6>New Messages</h6>
                <span>{unreadMessages.length} chat{unreadMessages.length === 1 ? '' : 's'}</span>
              </div>
              <div className='messageDropdownBody'>
                {unreadMessages.length === 0 ? (
                  <div className='messageDropdownEmpty'>
                    No unread messages right now.
                  </div>
                ) : (
                  unreadMessages.map((message) => (
                    <button
                      key={message.userId}
                      type='button'
                      className='messageDropdownItem'
                      onClick={() => openMessageThread(message)}
                    >
                      <img src={message.avatar} alt={message.name} className='messageDropdownAvatar' />
                      <div className='messageDropdownContent'>
                        <div className='messageDropdownTop'>
                          <strong>{message.name}</strong>
                          <span>{formatMessageTime(message.timestamp)}</span>
                        </div>
                        <p>{formatMessagePreview(message.preview) || message.course || "Open conversation"}</p>
                      </div>
                      <span className='messageDropdownUnread'>{message.unreadCount}</span>
                    </button>
                  ))
                )}
              </div>
              <button
                type='button'
                className='messageDropdownFooter'
                onClick={goToWorkspace}
              >
                Open workspace
              </button>
            </div>
          )}
          </div>
          <div className='messageDropdownWrap' ref={notificationDropdownRef}>
          <button
            type='button'
            className='NotifCont messageToggleBtn'
            onClick={() => setIsNotificationOpen((currentValue) => !currentValue)}
          >
            <FontAwesomeIcon icon={faBell} className="dashNoticIcon "/>
            {totalNotificationCount > 0 && (
              <p className='notifCounter2'>{totalNotificationCount > 99 ? '99+' : totalNotificationCount}</p>
            )}
          </button>
          {isNotificationOpen && (
            <div className='messageDropdownMenu'>
              <div className='messageDropdownHeader'>
                <h6>Notifications</h6>
                <span>{totalNotificationCount} unread</span>
              </div>
              <div className='messageDropdownBody'>
                {totalNotificationCount === 0 ? (
                  <div className='messageDropdownEmpty'>
                    No unread notifications right now.
                  </div>
                ) : (
                  <div className='messageDropdownSections'>
                    <section className='messageDropdownSection'>
                      <div className='messageDropdownSectionHeader'>
                        <strong>New Assignment Submissions</strong>
                        <span>{unreadAssignmentSubmissions.length} unread</span>
                      </div>
                      {unreadAssignmentSubmissions.length === 0 ? (
                        <div className='messageDropdownSectionEmpty'>
                          No unread assignment submissions right now.
                        </div>
                      ) : (
                        <div className='messageDropdownSectionList'>
                          {unreadAssignmentSubmissions.map((submission) => (
                            <button
                              key={submission.id}
                              type='button'
                              className='messageDropdownItem'
                              onClick={() => openAssignmentSubmission(submission)}
                            >
                              <img src={submission.avatar} alt={submission.studentName} className='messageDropdownAvatar' />
                              <div className='messageDropdownContent'>
                                <div className='messageDropdownTop'>
                                  <strong>{submission.studentName}</strong>
                                  <span>{formatMessageTime(submission.timestamp)}</span>
                                </div>
                                <p>{formatAssignmentSubmissionPreview(submission)}</p>
                              </div>
                              <span className='messageDropdownUnread'>1</span>
                            </button>
                          ))}
                        </div>
                      )}
                    </section>

                    <section className='messageDropdownSection'>
                      <div className='messageDropdownSectionHeader'>
                        <strong>New Firefly Reports</strong>
                        <span>{fireflyUnreadReports.length} unread</span>
                      </div>
                      {fireflyUnreadReports.length === 0 ? (
                        <div className='messageDropdownSectionEmpty'>
                          No unread Firefly reports right now.
                        </div>
                      ) : (
                        <div className='messageDropdownSectionList'>
                          {fireflyUnreadReports.map((report) => (
                            <button
                              key={`${report.studentId}-${report.id}`}
                              type='button'
                              className='messageDropdownItem'
                              onClick={() => openFireflyReport(report)}
                            >
                              <img src={report.avatar} alt={report.studentName} className='messageDropdownAvatar' />
                              <div className='messageDropdownContent'>
                                <div className='messageDropdownTop'>
                                  <strong>{report.studentName}</strong>
                                  <span>{formatMessageTime(report.timestamp)}</span>
                                </div>
                                <p>{report.sessionFocus || formatMessagePreview(report.summary) || 'New Firefly learning report'}</p>
                              </div>
                              <span className='messageDropdownUnread'>1</span>
                            </button>
                          ))}
                        </div>
                      )}
                    </section>
                  </div>
                )}
              </div>
              <div className='messageDropdownFooterGroup'>
                <button
                  type='button'
                  className='messageDropdownFooter'
                  onClick={() => {
                    setIsNotificationOpen(false);
                    navigate('/assignments');
                  }}
                >
                  Open assignments
                </button>
                <button
                  type='button'
                  className='messageDropdownFooter'
                  onClick={() => {
                    setIsNotificationOpen(false);
                    navigate('/my-courses', { state: { openTab: 'firefly' } });
                  }}
                >
                  Open Firefly reports
                </button>
              </div>
            </div>
          )}
          </div>
          <div className='profileDropdownWrap' ref={profileDropdownRef}>
            <button
              type='button'
              className='profCont profileToggleBtn'
              onClick={() => {
                setIsMessagesOpen(false);
                setIsNotificationOpen(false);
                setIsProfileMenuOpen((currentValue) => !currentValue);
              }}
            >
              <img src={userProfilePicture} alt="" />
            </button>
            {isProfileMenuOpen && (
              <div className='profileDropdownMenu'>
                <button type='button' className='profileDropdownItem' onClick={goToProfile}>
                  My Profile
                </button>
                <button type='button' className='profileDropdownItem' onClick={goToEditProfile}>
                  Settings
                </button>
                <button type='button' className='profileDropdownItem profileDropdownItemDanger' onClick={handleLogout}>
                  Logout
                </button>
              </div>
            )}
          </div>

          </div>
          <div className='mobileBottomNav'>
            <NavLink to="/dashboard" className={({ isActive }) => `mobileBottomNavLink ${isActive ? "mobileBottomNavLinkActive" : ""}`}>
              <FontAwesomeIcon icon={faHome} />
              <span>Home</span>
            </NavLink>
            <NavLink to="/my-courses" className={({ isActive }) => `mobileBottomNavLink ${isActive ? "mobileBottomNavLinkActive" : ""}`}>
              <FontAwesomeIcon icon={faBookOpen} />
              <span>Courses</span>
            </NavLink>
            <NavLink to="/assignments" className={({ isActive }) => `mobileBottomNavLink ${isActive ? "mobileBottomNavLinkActive" : ""}`}>
              <FontAwesomeIcon icon={faClipboardList} />
              <span>Tasks</span>
            </NavLink>
            <NavLink to="/workspace" className={({ isActive }) => `mobileBottomNavLink ${isActive ? "mobileBottomNavLinkActive" : ""}`}>
              <FontAwesomeIcon icon={faComments} />
              <span>Chat</span>
            </NavLink>
            <NavLink to="/profile" className={({ isActive }) => `mobileBottomNavLink ${isActive ? "mobileBottomNavLinkActive" : ""}`}>
              <FontAwesomeIcon icon={faUser} />
              <span>Profile</span>
            </NavLink>
          </div>
  </div>
  )
}

export default DashnavIn
